var selected_vId;
var modal;
var overlay;
var divClone;
var packageId = 7335571062820;
var topupsId = 7335584006180;
var newURL = "";
var manualInput = false;

// For package price + topup price + product price itself
var products;
var package_price = 0;
var topup_price = 0;
var product_price = 0;

var productObj = []


$(document).ready(function(){
  $('.dropify').dropify();

  modal = document.getElementById('newModal');
  overlay = document.getElementById('overlayProduct');

  var currentURL = document.URL;

  if(currentURL.includes('?variant')){
    newURL = (currentURL.substring(0, currentURL.indexOf('?'))).toString();
    newURL = newURL + ".js"
  }
  else{
    newURL = currentURL.toString() + ".js";
  }

  if ($(window).width() >= 1024 ){
    $(".sticky_js").stick_in_parent({
      offset_top: 200
    })
    .on("sticky_kit:stick", function(e) {
      // console.log("has stuck!", e.target);
      console.log('Stick desktop');
      $(e.target).css('top','43px');
    })
    .on("sticky_kit:unstick", function(e) {
      // console.log("has unstuck!", e.target);
    });
  }


  // set default values
  $('#packagecard-'+packageId).css({'-webkit-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', '-moz-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'border-color': 'white', 'background-color' : 'black', 'color' : 'white', 'font-weight' : 'bold' });
  $('#proTitle-'+packageId).addClass('selectedOption');
  $('#topups-'+topupsId).css({'-webkit-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', '-moz-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'border-color': 'white', 'background-color' : 'black', 'color' : 'white', 'font-weight' : 'bold' });
  $('#top-'+topupsId).css({'color' : '#ffffff !important'});
  jQuery.getJSON(newURL, function(product) {
    products = product; //set intial product json

    var f_id = $('#first_selected_vID').val();
    product_price = products.price;
    for(var temp in products.variants)
    {
      if(f_id == products.variants[temp].id)
      {
        // var str = (product.variants[temp].featured_image.src).toString();
        // var getSKU = str.substring(str.lastIndexOf("/")+1,str.lastIndexOf("-"));
        //
        // for(var i = 0; i< products.images.length; i++)
        // {
        //   var tem = (products.images[i]).toString();
        //   if(tem.includes(getSKU))
        //   {
        //     i = i+1;
        //     var s = "<img class='img_step2' style='max-width: 60%;' src='"+products.variants[temp].featured_image.src+"'/>"
        //     document.getElementById("step2Image").innerHTML = s;
        //     break;
        //   }
        // }
        //
        // var s = "<img class='img_step2' style='max-width: 60%;' src='"+products.variants[temp].featured_image.src+"'/>"
        // document.getElementById("step2Image").innerHTML = s;

        var newHTML = "<img class='hideClass' style='width: 50%;' src='"+products.variants[temp].featured_image.src+"'/>";
        document.getElementById("variantImage").innerHTML = newHTML;
      }
    }
  });

  $('#withPrescription').on('click', function(event) {
   $('#prescription-choice').toggle('show');
  });

  $('#confirm-step1').click(function(){
    $('#prescriptionpackage, #plusPrescription, #prescriptionTopUps, #step1Title, #topupTitle, .topUpTitle').hide();
    $(this).hide() // hide step 1 button
    $('#confirm-step2, #confirm-step2-previous').show(); // show step 2 button
    $('#prescriptionDetail, #termStep2, #termsText, #terms, #step2Title').fadeIn(); // show prescription detail
  });

  $('#confirm-step2').click(function(){

    if(manualInput){
      var check = validationChecking();
    }
    else{
      // if it's file upload check file length
      if(document.getElementById("dropify").files.length != 0){
        check = true;
        $('#file_error').hide();
      }
      else{
        check = false;
        $('#file_error').show();
      }

    }

    if(check){
      if($('#terms').prop('checked') == false){
        $('#termsMessage').show();
      }
      else
      {
        $('#termsMessage').hide();
        $('#leftEye, #rightEye, #uploadFor, #termsText, #terms ,#descriptionButton, #backButtonForStep2, #confirm-step2-previous, #step2Title').hide();
        $(this).hide() // hide step 2 button

        $('#confirmPayment, #confirm-step3-previous').show(); // show step 2 button
        $('#delieveryMethod, #step3Title').fadeIn(); // show prescription detail
      }
    }
  });

  $('#descriptionButton').on('click', function(event) {
   $('#uploadFor, #descriptionButton').hide();
   $('#leftEye, #rightEye, #backButtonForStep2').fadeIn();

  });

  $('#confirm-step2-previous').on('click', function(event){
    $('#prescriptionDetail, #confirm-step2, #confirm-step2-previous, #step2Title').hide();
    $('#prescriptionpackage, #confirm-step1, #step1Title, #topupTitle, .topUpTitle').fadeIn('slow');

    if(packageId == '7335573028900'){
      $('#plusPrescription, #prescriptionTopUps, #topupTitle, .topUpTitle').hide()
    }
    else{
      $('#plusPrescription, #prescriptionTopUps, #topupTitle, .topUpTitle').fadeIn()
    }

  });

  $('#confirm-step3-previous').on('click', function(event){

    $('#delieveryMethod, #confirm-step3, #confirmPayment, #step3Title').hide();
    $(this).hide();
    $('#prescriptionDetail,#step2Title ,#uploadFor,#termStep2,#termsText, #terms ,#descriptionButton, #confirm-step2, #confirm-step2-previous').fadeIn('slow');
  });


  $('#backButtonForStep2').on('click', function(event){
    $('#leftEye, #rightEye, #backButtonForStep2').hide();
    $('#uploadFor, #descriptionButton').fadeIn();
  });

  $('.collectionVariantImg').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.collectionVariantImg_index').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });



  $('.search_link').hover(function(){
    $('.csl_search').show();
  });

  // stickyFilter();
  filterZIndex();
});

directProduct = (url) => {
  location.href = url;
}

//Filter Z-index
filterZIndex = () =>{
  $('.filter-active-tag > button').on('click', function(){
    setTimeout(function(){
      $('.js-filterby').css('display','none');
      $('.js-filterby').addClass('d-shownone');
      $('.js-csl_zindex .product-list .thumbnail').css('z-index','-1');
      // $('.js-down_arrow').toggle();
      // $('.js-up_arrow').toggle();
    },1000);
  })
  $('.filter-all-tags > li > a > label > input').on('click',function(){
    console.log('yes');
    setTimeout(function(){
      $('.js-filterby').css('display','none');
      $('.js-filterby').addClass('d-shownone');
      $('.js-csl_zindex .product-list .thumbnail').css('z-index','-1');
      // $('.js-down_arrow').toggle();
      // $('.js-up_arrow').toggle();
    },1000);
  });
}

// When user click the filter option execute this function to close filter to enable to click product
$('body').on('change', '[data-option-filter] input', function(){
  filterbyFunction();
});

// start of scripts for filter
var checkClick = 1;
filterbyFunction = () =>{

  checkClick+=1;
  var resultClick = checkClick % 2;
  if (resultClick == 1) {
    $('.js-csl_zindex .product-list .thumbnail').css('z-index','0');
  }
  if (resultClick == 0) {
    $('.js-csl_zindex .product-list .thumbnail').css('z-index','-1');
  }

  $('.js-filterby').toggle();
  if ($('.js-filterby').hasClass('d-shownone')) {
    $('.js-filterby').removeClass('d-shownone');
    $('.js-filterby').css('z-index',9999);

  }
  else{
    $('.js-filterby').addClass('d-shownone');
  }
  $('.js-down_arrow').toggle();
  $('.js-up_arrow').toggle();
}
// end of scripts for filter

function retrieveId(evt, vid){
  var id = $(evt).data('description');

  //Change description according to the variant that user choose
  //************************************************************
  $('div.d-block').addClass('d-none');
  $('div.d-block').removeClass('d-block');
  $('#'+vid).removeClass('d-none');
  $('#'+vid).addClass('d-block');
  //************************************************************

  for(var temp in products.variants)
  {
    if(vid == products.variants[temp].id)
    {

      // var str = (products.variants[temp].featured_image.src).toString();
      // var getSKU = str.substring(str.lastIndexOf("/")+1,str.lastIndexOf("-"));
      //
      // for(var i = 0; i< products.images.length; i++)
      // {
      //   var tem = (products.images[i]).toString();
      //   if(tem.includes(getSKU))
      //   {
      //     i = i+1;
      //
      //     break;
      //   }
      // }

      // var s = "<img class='img_step2' style='max-width: 60%;' src='"+products.variants[temp].featured_image.src+"'/>"
      // document.getElementById("step2Image").innerHTML = s;

      var newHTML = "<img class='hideClass' style='width: 50%;' src='"+products.variants[temp].featured_image.src+"'/>"
      document.getElementById("variantImage").innerHTML = newHTML;
    }
  }
}

function showModal(){
  $('.newModal').fadeIn('slow');
  $('.overlayProduct').fadeIn('fast');


}

function closeModal(){
  $('.overlayProduct').hide();
  $('.newModal').hide();

  $('#dateSchedule').val('');
  $('#TimeInterval').val('');
}

// Function set packageID from user selection
function setPackageId(evt, id, price){
  if(packageId != id)
  {
    $(evt).css({'-webkit-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', '-moz-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'border-color': 'white', 'background-color' : 'black', 'color' : 'white', 'font-weight' : 'bold' });
    $('#packagecard-'+id).children('#package_description').children('.lensSmaller').addClass('selectedOption');

    $('#packagecard-'+packageId).css({'-webkit-box-shadow' : 'none', '-moz-box-shadow' : 'none', 'box-shadow' : 'none', 'border-color': 'black', 'background-color': 'white',  'color' : 'black', 'font-weight' : 'normal' });
    $('#packagecard-'+packageId).children('#package_description').children('.lensSmaller').removeClass('selectedOption');
  }
  if(id == '7335573028900'){
    $('#plusPrescription, #prescriptionTopUps, #topupTitle, .topUpTitle').hide()
    $('#confirm-step1').prop('disabled', false);
    topup_price = 0;
  }
  else{
    $('#plusPrescription, #prescriptionTopUps, #topupTitle, .topUpTitle').fadeIn()
    // $('#confirm-step1').prop('disabled', true);
  }

  packageId = id;
  package_price = price;

  // checkStep1Btn();
  addCustomisationPrice();
}

function checkStep1Btn(){
  if(packageId > 0 && topupsId > 0){
    $('#confirm-step1').prop('disabled', false);
  }
}

function setTopupsId(evt, id, price){
  if(topupsId != id)
  {
    $(evt).css({'-webkit-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', '-moz-box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'box-shadow' : '0px 10px 17px -2px rgba(0,0,0,0.28)', 'border-color': 'white', 'background-color' : 'black', 'color' : 'white', 'font-weight' : 'bold' });
    $('#top-'+id).css({'color' : '#ffffff !important'});
    $('#topups-'+topupsId).css({'-webkit-box-shadow' : 'none', '-moz-box-shadow' : 'none', 'box-shadow' : 'none', 'border-color': 'black', 'background-color': 'white',  'color' : 'black', 'font-weight' : 'normal' });
    $('#top-'+topupsId).css({'color' : '#000000 !important'});
  }

  topupsId = id;
  topup_price = price;
  // checkStep1Btn();
  addCustomisationPrice();
}

function prependSphere(evt){
  var value = $(evt).val();
  var nextInput = $(evt).next();
  var text = nextInput.val();
  var newString = text[0];

  if (newString == '-' || newString == '+'){
    var newText = text.substr(1,text.length);
    nextInput.val(value + newText);
  }
  else{
      nextInput.val(value + text);
  }
}

function validationChecking(){

  var flag = true;

  var l_sphere = $('#l-sphere');
  var ans_sphere = checkSphere(l_sphere.val(), l_sphere.attr('id'));
  if(!ans_sphere){ flag = false};

  var l_cylinder = $('#l-cylinder');
  var ans_cylinder = checkCylinder(l_cylinder.val(), l_cylinder.attr('id'));
  if(!ans_cylinder){ flag = false};

  var l_axis = $('#l-axis');
  var ans_axis = checkAxis(l_axis.val(), l_axis.attr('id'))
  if(!ans_axis){flag =false};

  var l_pd = $('#l-pd');
  var ans_pd = checkAxis(l_pd.val(), l_pd.attr('id'))
  if(!ans_pd){flag =false};


  var r_sphere = $('#r-sphere');
  var ans_rsphere = checkSphere(r_sphere.val(), r_sphere.attr('id'));
  if (!ans_rsphere){ flag = false};

  var r_cylinder = $('#r-cylinder');
  var ans_rcylinder = checkCylinder(r_cylinder.val(), r_cylinder.attr('id'));
  if(!ans_rcylinder){ flag = false};

  var r_axis = $('#r-axis');
  var ans_raxis = checkAxis(r_axis.val(), r_axis.attr('id'))
  if(!ans_raxis){flag =false};

  var r_pd = $('#r-pd');
  var ans_rpd = checkAxis(r_pd.val(), r_pd.attr('id'))
  if(!ans_rpd){flag =false};

  return flag;
}

function checkCylinder(value, id){
  // console.log(isNaN(value), parseFloat(value), 'hey', value.toString().indexOf('.'));
  var n = parseFloat(value);
  if(!isNaN(parseFloat(value))){
    // dropdown
    $('#'+id+'_error').hide();
    if($('#'+id).prev().find(":selected").text() == 'Choose'){
      $('#'+id+'_error_dropdown').show();
      return false;
    }
    else{
      $('#'+id+'_error_dropdown').hide();
      var n = (parseFloat(value)).toFixed(2);
      var n1 = parseFloat(-300.00);
      var n2 = parseFloat(-0.25)
      if( n < n1 || n > n2){
        $('#'+id+'_error_range').show();
        return false;
      }
      else{
        $('#'+id+'_error_range').hide();
        return true;
      }
    }
  }
  else{
    // Show must be an integer format
    $('#'+id+'_error').show();
    return false;
  }
}

function checkSphere(value, id){
  if(Isinteger(value)){
    // dropdown
    $('#'+id+'_error').hide();
    if($('#'+id).prev().find(":selected").text() == 'Choose'){
      $('#'+id+'_error_dropdown').show();
      return false;
    }
    else{
      $('#'+id+'_error_dropdown').hide();
      var n = parseInt(value);
      if( n < -1000 || n > +4){
        $('#'+id+'_error_range').show();
        return false;
      }
      else{
        $('#'+id+'_error_range').hide();
        return true;
      }
    }
  }
  else{
    // Show must be an integer format
    $('#'+id+'_error').show();
    return false;
  }
}

function checkAxis(value, id){
  if(Isinteger(value)){
    // dropdown
    $('#'+id+'_error').hide();
    var n = parseInt(value);
    if( n < 0 || n > 180){
      $('#'+id+'_error_range').show();
      return false;
    }
    else{
      $('#'+id+'_error_range').hide();
      return true;
    }

  }
  else{
    // Show must be an integer format
    $('#'+id+'_error').show();
    return false;
  }
}

function checkPD(value, id){
  if(Isinteger(value)){
    // dropdown
    $('#'+id+'_error').hide();
    var n = parseInt(value);
    if( n < 50 || n > 70){
      $('#'+id+'_error_range').show();
      return false;
    }
    else{
      $('#'+id+'_error_range').hide();
      return true;
    }

  }
  else{
    // Show must be an integer format
    $('#'+id+'_error').show();
    return false;
  }
}

function Isinteger(input){

  if(!isNaN(parseInt(input))){
    return true;
  }
  else{
    return false;
  }
}

function setCheck(){
  manualInput = true;
  $('#file_error').hide();
}

function setUpload(){
  manualInput = false;
  $('#file_error').hide();
}

function addCustomisationPrice(){
  var ans = (product_price/100) + (package_price/100) + (topup_price/100);
  ans = ans.toFixed(2);
  $('#finalPrice').text('S$'+ans);
}

function setDeliverySelection(evt){
  var newValue = $(evt).val();
  $('#deliverySelection').val(newValue);
}

function addPackageTopUp(){
  addToCartAjax(topupsId);

  setTimeout(function(){
    addToCartAjax(packageId)
  },1500);

  setTimeout(function(){
    $("#triggerAddCart").click();
  },2500);

}

function addToCartAjax(vid){
  $.post('/cart/add.js', {
    quantity: 1,
    id: vid
  });
}


$('.targeting').on('click',function(){

  var $id = $(this).attr('href');
  var newid = $id.replace('#', '');
  var slickdots =$(this).parent().parent().next().children().children();

  $('.collectionVariantImg_index').css('visibility', 'hidden');
  $('.collectionVariantImg_index').slick('unslick');

  $('.collectionVariantImg_index').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.collectionVariantImg_index').css('visibility', 'visible');


  // slickdots.each(function(){
  //   var checkid = ($(this).attr('id')).trim();
  //   if (checkid == newid){
  //     var targetbtn = $(this).find('.slick-dots').find('button');
  //     targetbtn.trigger('click');
  //   }
  // })

})

// stickyFilter = () =>{
//   $(".sticky_js").stick_in_parent()
//     .on("sticky_kit:stick", function(e) {
//       console.log("has stuck!", e.target);
//       $(e.target).css('top','54px');
//       $(e.target).css('z-index','99');
//       $(e.target).css('background','#ffffff');
//   })
//     .on("sticky_kit:unstick", function(e) {
//       console.log("has unstuck!", e.target);
//   });
//
//   $(".sticky_js_dropdown").stick_in_parent()
//     .on("sticky_kit:stick", function(e) {
//       console.log("has stuck!", e.target);
//       $(e.target).css('top','110px');
//       $(e.target).parent().css('display','block');
//   })
//     .on("sticky_kit:unstick", function(e) {
//       console.log("has unstuck!", e.target);
//   });
// }
